import { get, filter, size, map } from "lodash";

import {
  selectSite,
  selectTab,
  setInitialized,
} from "../actions/siteEntranceExit/";
import { resetTabs, addTab } from "../actions/siteEntranceExit/tabs";
import { initiateZone } from "../actions/siteEntranceExit/liveEvents";

import { fetchGlobalPreferences, initSite } from "./userDataStore";

import { driveInOut, walkInOut, trainInOut } from "../constants/reducers";
import { LOGS_TAB, STATIC_TAB } from "../constants/siteEntranceExit";
import { LOG_EVENT_GROUP_TYPES } from "../constants/logEventGroupTypes";
import { setViewUnmatched } from "../actions/common";

export const handleSiteSelect = async (dispatch, section, activeSite, site) => {
  if (!activeSite || get(activeSite, ["id"]) !== site.id) {
    dispatch(selectSite(section, site));

    // Reset Tabs
    await dispatch(setInitialized(section, false));
    await dispatch(resetTabs(section));

    // Fetch preferences from data store
    let globalPreferences = await fetchGlobalPreferences(dispatch, section);

    // Create Logs tab
    await dispatch(
      addTab(section, 0, {
        type: LOGS_TAB,
        logs: {
          rowsPerPage: get(globalPreferences, ["rowsPerPage"]),
          collapsed: get(globalPreferences, ["collapsedSections"]),
        },
        logTypes: get(LOG_EVENT_GROUP_TYPES, section),
        zoneIds: map(
          filter(
            site.zones,
            (z) => is_zone_in_section(z, section, z.active)
          ),
          (z) => z.id
        ),
      })
    );
    let tab_count = 1;

    await dispatch(
      setViewUnmatched(
        section,
        get(globalPreferences, ["viewUnmatchedPhotos"]),
        false
      )
    );
    await initSite(dispatch, section, site.id);

    await dispatch(selectTab(section, 0));

    // Create Live tabs for entry and exit zones
    // Note the complexity here is solely for making sure that the tabs are created
    // in the following order:  Thru zones (that are both entrances and exits), entry zones, exit zones.

    const zones = filter(
      get(site, ["zones"]),
      (z) => is_zone_in_section(z, section)
    );

    tab_count += create_static_tabs(dispatch, section, zones, tab_count);

    dispatch(setInitialized(section, true));
  }
};

export const getSiteName = (siteId, companies) => {
  return get(
    filter(
      get(
        filter(
          companies,
          (c) => size(filter(get(c, ["sites"]), (s) => s.id === siteId)) > 0
        ),
        [0, "sites"]
      ),
      (s) => s.id === siteId
    ),
    [0, "name"]
  );
};

// Note: similar logic is used elsewhere.  Consider moving this to a
// separate utility function.
function is_zone_in_section(zone, section, active = undefined) {
  // Note: the effect of active being un-defined will cause both
  // active and inactive zones in the section to be true.
  return (typeof active === 'boolean' ? zone.active === active : true) 
    && (section === driveInOut
    ? zone.is_vehicle_access
    : section === walkInOut
    ? zone.is_human_access
    : section === trainInOut
    ? zone.is_train_access
    : true);
}

// Creates static tabs and returns the number of tabs created.
async function create_static_tabs(dispatch, section, zones, tab_count) {
  let zones_size = size(zones);
  if (zones_size > 0) {
    for (let i = 0; i < zones_size; i++) {
      await dispatch(
        addTab(section, i + tab_count, {
          type: STATIC_TAB,
          title: zones[i].name,
          zone: zones[i],
        })
      );
      await dispatch(initiateZone(section, zones[i].id));
    }
  }
  return zones_size;
}

